"use client";

import { Info } from "lucide-react";
import { useRuntimeConfig } from "@/lib/runtime-config";

export function EnvironmentBanner() {
  const { uatMode } = useRuntimeConfig();

  if (!uatMode) return null;

  return (
    <div className="environment-banner" role="status" aria-label="UAT environment">
      <Info size={14} strokeWidth={2.25} aria-hidden="true" />
      <span>
        <strong>UAT environment</strong>
        <span>Testing only - do not use for live work.</span>
      </span>
    </div>
  );
}
